<template>
  <b-form-group label="Assign to folder">
    <b-form-row>
      <b-col>
        <Multiselect
          v-model="folder"
          label="name"
          track-by="id"
          :options="folders"
          placeholder="None"
          select-label=""
          deselect-label=""
          :disabled="!!folderId"
        />
        <input
          type="hidden"
          name="folder_id"
          :value="folder?.id"
        >
      </b-col>
      <b-col cols="auto">
        <b-button
          v-if="!folderId"
          v-b-modal.createLayoutFolderModal
          variant="primary"
        >
          New Folder…
        </b-button>
      </b-col>
    </b-form-row>
    <CreateLayoutFolderModal @ok="selectFolder" />
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import CreateLayoutFolderModal from './modals/CreateLayoutFolderModal.vue'

let hasInitialized = false;
export default {
  name: 'LayoutFolderSelect',

  components: {
    CreateLayoutFolderModal,
    Multiselect,
  },
  
  props: {
    folderId: {
      type: Number,
      required: false,
      default: null
    }
  },

  data: () => ({
    folder: null,
  }),

  computed: {
    ...mapGetters('layout', {
      folders: 'folders',
      folderDB: 'folder'
    }),
  },

  async created () {
    if (hasInitialized) {
      return
    }
    hasInitialized = true
    await this.fetchFolders({
      pageSize: 999,
      pageNumber: 1,
    })
  },
  
  async mounted() {
    if (this.folderId) {
      await this.getFolder(this.folderId);
      this.folder = this.folderDB;
    }
  },

  methods: {
    ...mapActions('layout', [
      'fetchFolders',
      'getFolder'
    ]),
    selectFolder (folder) {
      this.folder = folder
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.multiselect__tags) {
  height: 40px;
  border-radius: 16px;
}
</style>
